import { addQueryArgs } from '@wordpress/url';
import { getParamsOfUrl, getUrl } from '../mixins/search';
import { getWishListCookie, updateTotal } from './toggle-wishlist';
import { setCookie } from '../../mixins/cookie';

const wishlistNode = document.querySelector( '#wcbt-wishlist' );
const wishListTitleNode = wishlistNode.querySelector( '.wcbt-wishlist-title' );
const containerNode = wishlistNode.querySelector( '.wcbt-product-container' );
const messagePopup = document.querySelector( '#wcbt-snackbar' );
const { __ } = wp.i18n;
let popupTimeout;

//-----------
const restNamespace = WCBT_GLOBAL_OBJECT.rest_namespace || '';
const defaultQuery = { orderby: 'name', order: 'asc' };
let query = {};
const userId = WCBT_GLOBAL_OBJECT.user_id || '';

const wcbtListProduct = () => {
	if ( ! containerNode ) {
		return;
	}
	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}

	if ( ! userId ) {
		const productIds = getWishListCookie();
		query = { ...query, post_in: productIds };
	}

	getProducts( query );
	removeWishList();
};

const getProducts = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}
	const param = { ...defaultQuery, ...queryParam };
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/wishlist', param ), method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			if ( isLoadmore ) {
				containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
			} else {
				containerNode.innerHTML = res.data.content;
			}
		} else if ( res.msg && isLoadmore === false ) {
			containerNode.innerHTML = `<p>${ res.msg }</p>`;
		}
		pagination( res );
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		const params = query;
		if ( ! userId ) {
			delete params.post_in;
		}

		const urlPush = getUrl( params );
		window.history.pushState( '', '', urlPush );
		containerNode.style.opacity = 1;
	} );
};

const pagination = ( res ) => {
	if ( res.data.pagination !== undefined ) {
		wishlistNode.querySelector( '.wcbt-pagination' ).innerHTML = res.data.pagination;
	} else {
		wishlistNode.querySelector( '.wcbt-pagination' ).innerHTML = '';
	}

	if ( res.data.from_to !== undefined ) {
		wishlistNode.querySelector( '.wcbt-from-to' ).innerHTML = res.data.from_to;
	} else {
		wishlistNode.querySelector( '.wcbt-from-to' ).innerHTML = '';
	}

	const paginationNode = wishlistNode.querySelector( '.wcbt-pagination' );
	if ( !! paginationNode ) {
		const pageNodes = paginationNode.querySelectorAll( 'a' );
		for ( let i = 0; i < pageNodes.length; i++ ) {
			pageNodes[ i ].addEventListener( 'click', function( event ) {
				event.preventDefault();
				const page = this.getAttribute( 'data-page' );
				query = { ...query, page };
				if ( ! userId ) {
					query = { ...query, post_in: getWishListCookie() };
				}
				getProducts( query );
				wishlistNode.scrollIntoView( { behavior: 'smooth' } );
			} );
		}
	}
};

const removeWishList = () => {
	document.addEventListener( 'click', function( event ) {
		const removeNodes = containerNode.querySelectorAll( 'tr .product-remove' );

		if ( ! removeNodes ) {
			return;
		}

		for ( let i = 0; i < removeNodes.length; i++ ) {
			const removeNode = removeNodes[ i ];
			if ( removeNode.contains( event.target ) ) {
				event.preventDefault();
				let productId = removeNode.closest( 'tr' ).getAttribute( 'data-product-id' );
				productId = parseInt( productId );
				removeNode.disabled = true;
				if ( userId ) {
					const data = { product_id: productId };
					wp.apiFetch( {
						path: '/' + restNamespace + '/wishlist', method: 'POST', data,
					} ).then( ( res ) => {
						if ( res.status === 'success' ) {
							// wishListNode.classList.toggle( 'active' );
						}
						const query = {
							page: 1,
						};
						messagePopup.innerHTML = __( 'Product WishList removed', 'wcbt' );
						displayMessagePopup();
						updateTotal( res.data.total );
						getProducts( query );
					} ).catch( ( err ) => {
						console.log( err );
					} ).finally( () => {
						removeNode.disabled = false;
					} );
				} else {
					let productIds = getWishListCookie();
					if ( productIds && productIds.includes( productId ) ) {
						//Remove wishlist product
						productIds = productIds.filter( ( item ) => item !== productId );
						messagePopup.innerHTML = __( 'Product WishList removed', 'wcbt' );
					}

					setCookie( 'wcbt_wishlist_product', productIds.join( ',' ), 30 );

					displayMessagePopup();
					updateTotal( productIds.length );
					const query = {
						post_in: productIds,
					};

					getProducts( query );
				}
			}
		}
	} );
};

const displayMessagePopup = () => {
	messagePopup.classList.add( 'active' );
	if ( popupTimeout ) {
		clearTimeout( popupTimeout );
	}

	popupTimeout = setTimeout( () => {
		messagePopup.classList.remove( 'active' );
		messagePopup.innerHTML = '';
	}, '3000' );
};

export default wcbtListProduct;
